// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2coOf","Logo":"Toolbar_Logo__2nEro","DesktopOnly":"Toolbar_DesktopOnly__1Lq44"};